import * as types from '../actions/types'

const initialState = {
  actionMessage: {
    message: '',
    success: true,
  },
}

const actionFeedback = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_ACTION_MESSAGE:
      return {
        ...state,
        actionMessage: action.message,
      }
    default:
      return state
  }
}

export default actionFeedback
